import styled, { css } from 'styled-components';

export const RadioButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  align-self: stretch;

  background: var(--primary-background);
  cursor: pointer;
  height: 40px;
  border-radius: 4px 0px 0px 4px;
  border-top: 1px solid var(--accent-color-gray);
  border-bottom: 1px solid var(--accent-color-gray);
  border-left: 1px solid var(--accent-color-gray);

  &:last-child {
    border-radius: 0px 4px 4px 0px;
    border-top: 1px solid var(--accent-color-gray);
    border-right: 1px solid var(--accent-color-gray);
    border-bottom: 1px solid var(--accent-color-gray);
  }

  svg,
  svg path {
    fill: var(--grey500);
  }

  ${(props) =>
    !!props.checked &&
    css`
      background: var(--accent-color-blue);
      svg,
      svg path {
        fill: var(--primary-background);
      }
    `}

  ${(props) =>
    !!props.isDisabled &&
    css`
      opacity: 0.5;
      background: var(--grey200);
      cursor: default;
      svg,
      svg path {
        fill: var(--grey500);
      }
    `}

    ${(props) =>
    !!props.isDisabled &&
    !!props.checked &&
    css`
      opacity: 1;
      background: var(--grey200);
      svg,
      svg path {
        fill: var(--primary-background);
      }
    `}
`;
